import { computed, inject } from 'vue';
import { IMsg } from '_c/typings/model/im';

export default function (displayName = '') {
  const getMessageData = inject('getMessageData') as () => IMsg;
  const isTest = window.location.host !== 'm.gameplus.qq.com' && window.location.host !== 'm.noknok.cn';
  // 小迷妹等几个bot加群后的跳转信息需要屏蔽，以UID做屏蔽逻辑
  const botIdListMap = {
    test: ['100000007', '100009792', '100009838'],
    prod: ['100000015', '100005047', '100009804'],
  };
  const message = computed(() => getMessageData());
  return computed(() => {
    let sendUserId = message.value.senderUid;
    if (isTest) {
      if (-1 !== botIdListMap.test.indexOf(sendUserId.toString())) return '不支持的消息类型';
    } else {
      sendUserId = message.value.senderUid;
      if (-1 !== botIdListMap.prod.indexOf(sendUserId.toString())) return '不支持的消息类型';
    }
    return displayName;
  });
}
